import { lazy } from "react";

/**
 * The three room-list pages render in two places: as routes under `/y`, and as
 * the standing list panel beside the `<Outlet/>` in `layout.tsx`. Both sides
 * import these exact objects, so each page resolves to one chunk and one
 * suspense resolution rather than two.
 */
export const StringsPanel = lazy(() => import("./strings/index"));
export const KnotsPanel = lazy(() => import("./knots/index"));
export const LoopsPanel = lazy(() => import("./loops/index"));
